export default __webpack_public_path__ + "static/media/informatique.4bbc2928.svg";